export const locales = ["ko", "en", "ja", "zh", "zh-tw"] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

export const localeNames: Record<Locale, string> = {
  ko: "한국어",
  en: "English",
  ja: "日本語",
  zh: "中文(简体)",
  "zh-tw": "中文(繁體)",
};

export const htmlLangs: Record<Locale, string> = {
  ko: "ko",
  en: "en",
  ja: "ja",
  zh: "zh-CN",
  "zh-tw": "zh-TW",
};

export function isLocale(value: string): value is Locale {
  return locales.includes(value as Locale);
}
